export const enum VinSearchType {
  PARTNER_HEADER_WITH_LOGO = "partner header",
  BLUE_VIN_SEARCH = "blue vin search",
  GENERIC_HEADER = "generic header",
}

export interface ComponentSettings {
  isMainHeading: boolean;
  isModalStyled?: boolean;
  hasBlueBackground: boolean;
}

export const useSettings = (componentType: string): ComponentSettings => {
  switch (componentType) {
    case VinSearchType.BLUE_VIN_SEARCH:
      return {
        hasBlueBackground: true,
        isMainHeading: false,
        isModalStyled: true,
      };
    case VinSearchType.GENERIC_HEADER:
      return {
        hasBlueBackground: false,
        isMainHeading: true,
        isModalStyled: false,
      };
    default:
      return {
        hasBlueBackground: false,
        isMainHeading: false,
        isModalStyled: false,
      };
  }
};
